<template>
  <div class="journalism">
    <OtheHeader />
    <div class="content">
      <div class="breadcrumb">
        <img src="../assets/img/fangzi.png" alt style="width:16px;height:15px;margin-right:18px" />
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/">
              首页
            </router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>新闻</el-breadcrumb-item>
          <el-breadcrumb-item>{{labType}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="heade">
        <el-radio-group v-model="radio1" @change="changeFn">
          <el-radio-button v-for="item in newsClass" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="list">
        <div class="list-item" v-for="item in showList.list" :key="item.id">
          <router-link :to="{name: 'JournalismDetail', query: {id: item.id }}" target="_blank" style="display: flex; width: 100%;">
            <div class="list-img">
              <img
                :src="'http://develop.line-found.com/' + item.image"
                alt
                style="width:100%;height:100%;"
              />
            </div>
            <div class="list-body">
              <div>
                <p class="body-title">{{item.name}}</p>
                <p
                  class="body-date"
                >{{new Date(parseInt(item.createtime) * 1000).toLocaleString().split(' ')[0].replace('/', '-').replace('/', '-')}}</p>
                <p class="body-txt">{{deleteK(item.content)}}</p>
              </div>
              <el-button class="body-btn">查看详情</el-button>
            </div>
          </router-link>
        </div>
      </div>
      <div class="pagination">
        <!-- <span>共10页，共100条</span> -->
        <p>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="4"
            :total="showList.page.total"
            :current-page="pageNo"
            @current-change="handleCurrentPageChange"
          ></el-pagination>
        </p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import OtheHeader from "@/components/OtheHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Journalism",
  components: {
    OtheHeader,
    Footer
  },
  data() {
    return {
      radio1: 1,
      newsClass: [],
      pageNo: 1,
      showList: {
        list: [],
        page: {}
      },
      labType: ''
    };
  },
  created() {
    this.getNewsClass();
  },
  methods: {
    deleteK(str) {
      str = str.replace(/ &nbsp;/ig, '')
      str = str.replace(/&nbsp;/ig, '')
      return str
    },
    handleCurrentPageChange(selectedPageSize) {
      this.pageNo = selectedPageSize;
      this.getNewList();
    },
    changeFn(id) {
      this.radio1 = id;
      this.pageNo = 1;
      let labType = this.newsClass.find(v => {
        return id == v.id
      })
      this.labType = labType.name
      this.getNewList();
    },
    getNewsClass() {
      this.fetchGet("index/getNewsType")
        .then(res => {
          this.newsClass = res.data;
          this.radio1 = res.data[0].id;
          this.labType = res.data[0].name
          this.getNewList();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getNewList() {
      this.fetchGet("index/getNewsList", {
        type: this.radio1,
        listRows: 4,
        p: this.pageNo
      })
        .then(res => {
          this.showList = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="less">
.journalism {
  .pagination {
    // display: flex;
    margin-bottom: 74px;
    span {
      font-size: 12px;
      color: rgba(100, 100, 100, 1);
      margin-left: 25px;
    }
    p {
      // margin-left: 209px;
      text-align: center;
    }
  }
  .content {
    width: 1197px;
    margin: 0 auto;
    .breadcrumb {
      display: flex;
      margin-top: 30px;
    }
    .heade {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      .el-radio-button__inner {
        width: 109px;
        height: 38px;
        color: #666666;
        font-size: 12px;
        border-radius: 0;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #ffffff;
        background-color: #00a8eb;
      }
    }
    .list {
      margin-top: 26px;
      padding: 0 32px;
      box-sizing: border-box;
      .list-item {
        display: flex;
        margin-bottom: 36px;
        padding: 27px 34px;
        .list-img {
          flex-shrink: 0;
          width: 248px;
          height: 165px;
        }
        .list-body {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: calc(100% - 248px - 18px);
          height: 165px;
          margin-left: 18px;
          .body-title {
            color: #333333;
            font-size: 18px;
          }
          .body-date {
            color: #999999;
            font-size: 12px;
            margin-top: 4px;
          }
          .body-txt {
            width: 100%;
            color: #666666;
            font-size: 14px;
            margin-top: 10px;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .body-btn {
            width: 100px;
            height: 30px;
            color: #999999;
            font-size: 14px;
            border-color: #999999;
            border-radius: 0;
            padding: 0;
          }
        }
      }
      .list-item:hover {
        background-color: #eef0f0;
        cursor: pointer;
      }
      .list-item:hover .body-btn {
        background-color: #00a8eb;
        color: #ffffff;
        border: none;
      }
    }
  }
}
</style>
